export default __webpack_public_path__ + "static/Trust Alice Splash Screen-325cab9aeec584153344abcf128c9f9e.png";